"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;

var _stylitas = require("@creditas/stylitas");

const timingFunction = (0, _stylitas.css)`
  animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
`;
const bounceInRight = (0, _stylitas.keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    ${timingFunction}
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
`;
const bounceOutRight = (0, _stylitas.keyframes)`
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
`;

const positionHelper = position => {
  const sidePositions = (0, _stylitas.mediaValue)('0px', '50px');

  switch (position) {
    case 'top-right':
      return (0, _stylitas.css)`
        top: 50px;
        ${(0, _stylitas.mq)({
        right: sidePositions
      })}
      `;

    case 'top-left':
      return (0, _stylitas.css)`
        top: 50px;
        ${(0, _stylitas.mq)({
        left: sidePositions
      })}
      `;

    case 'bottom-left':
      return (0, _stylitas.css)`
        bottom: 50px;
        ${(0, _stylitas.mq)({
        left: sidePositions
      })}
      `;

    case 'bottom-right':
    default:
      return (0, _stylitas.css)`
        bottom: 50px;
        ${(0, _stylitas.mq)({
        right: sidePositions
      })}
      `;
  }
};

const container = ({
  position
}) => (0, _stylitas.css)`
  position: fixed;
  z-index: 10000;
  ${positionHelper(position)}

  > div {
    animation: ${bounceInRight} 1s;
    box-shadow: 0px 8px 16px 0px rgba(170, 187, 187, 0.5);

    &.bounce-out {
      animation: ${bounceOutRight} 1.5s;
    }
  }
`;

exports.container = container;